import {
  CSProductResourcePage_Sections_Section_Items_Subsection_Items_Asset,
  CSProductResourcePage_Sections_Section_Items_Subsection_Items_BuildingInstruction,
  CSProductResourcePage_Sections_Section_Items_Subsection_Items_Cta,
  CSProductResourcePage_Sections_Section_Items_Subsection_Items_Link,
  CSProductResourcePage_Sections_Section_Items_Subsection_Items_Pdf,
  CSProductResourcePage_Sections_Section_Items_Subsection_Items_Text,
} from '@websrc/Typings/ContentStack'

import type {
  mapAssetItem,
  mapBuildingInstructionItem,
  mapCTAItem,
  mapLinkItem,
  mapResourcePageSectionItem,
  mapSupportPDFItem,
  mapTextItem,
} from '../mapResourcePageSectionsItem'

export type Item =
  | CSProductResourcePage_Sections_Section_Items_Subsection_Items_Text
  | CSProductResourcePage_Sections_Section_Items_Subsection_Items_Asset
  | CSProductResourcePage_Sections_Section_Items_Subsection_Items_Link
  | CSProductResourcePage_Sections_Section_Items_Subsection_Items_BuildingInstruction
  | CSProductResourcePage_Sections_Section_Items_Subsection_Items_Pdf
  | CSProductResourcePage_Sections_Section_Items_Subsection_Items_Cta

export type MappedItem = ReturnType<typeof mapResourcePageSectionItem>

export function isText(
  item: Item
): item is CSProductResourcePage_Sections_Section_Items_Subsection_Items_Text {
  return (
    (item as CSProductResourcePage_Sections_Section_Items_Subsection_Items_Text).text !== undefined
  )
}

export function isAsset(
  item: Item
): item is CSProductResourcePage_Sections_Section_Items_Subsection_Items_Asset {
  return (
    (item as CSProductResourcePage_Sections_Section_Items_Subsection_Items_Asset).asset !==
    undefined
  )
}

export function isLink(
  item: Item
): item is CSProductResourcePage_Sections_Section_Items_Subsection_Items_Link {
  return (
    (item as CSProductResourcePage_Sections_Section_Items_Subsection_Items_Link).link !== undefined
  )
}

export function isBuildingInstruction(
  item: Item
): item is CSProductResourcePage_Sections_Section_Items_Subsection_Items_BuildingInstruction {
  return (
    (item as CSProductResourcePage_Sections_Section_Items_Subsection_Items_BuildingInstruction)
      .building_instruction !== undefined
  )
}

export function isSupportPDF(
  item: Item
): item is CSProductResourcePage_Sections_Section_Items_Subsection_Items_Pdf {
  return (
    (item as CSProductResourcePage_Sections_Section_Items_Subsection_Items_Pdf).pdf !== undefined &&
    Boolean(
      (item as CSProductResourcePage_Sections_Section_Items_Subsection_Items_Pdf).pdf.pdf?.length
    )
  )
}

export function isCTAItem(
  item: Item
): item is CSProductResourcePage_Sections_Section_Items_Subsection_Items_Cta {
  return (
    (item as CSProductResourcePage_Sections_Section_Items_Subsection_Items_Cta).cta !== undefined
  )
}

export function isMappedText(item: MappedItem): item is ReturnType<typeof mapTextItem> {
  return (item as ReturnType<typeof mapTextItem>).text !== undefined
}

export function isMappedLink(item: MappedItem): item is ReturnType<typeof mapLinkItem> {
  return (item as ReturnType<typeof mapLinkItem>).link !== undefined
}

export function isMappedAsset(item: MappedItem): item is ReturnType<typeof mapAssetItem> {
  return (item as ReturnType<typeof mapAssetItem>).asset !== undefined
}

export function isMappedBuildingInstruction(
  item: MappedItem
): item is ReturnType<typeof mapBuildingInstructionItem> {
  return (item as ReturnType<typeof mapBuildingInstructionItem>)?.buildingInstruction !== undefined
}

export function isMappedSupportPDF(item: MappedItem): item is ReturnType<typeof mapSupportPDFItem> {
  return (item as ReturnType<typeof mapSupportPDFItem>)?.pdf !== undefined
}

export function isMappedCtaItem(item: MappedItem): item is ReturnType<typeof mapCTAItem> {
  return (item as ReturnType<typeof mapCTAItem>)?.cta !== undefined
}
